__webpack_require__.p = "https://ikea.marat.qd.je/bh/en/local-apps/alsulaiman-purchase-handler/";